import Event from 'eventemitter2'
import { markRaw } from 'vue'
import type { IRouter } from './IRouter'
import NotRegisteredRouteError from './NotRegisteredRouteError'
import type {
  RegisterRoute,
  RouteHistory,
  RouterPushParams,
} from './RouterTypes'

class PopupRouter implements IRouter {
  eventEmitter: Event
  history: RouteHistory[]
  currentRoute: RouteHistory | undefined
  currentRouteIndex: number

  constructor(public registeredRoutes: RegisterRoute[]) {
    this.eventEmitter = new Event()
    this.history = []
    this.currentRouteIndex = -1
  }
  forward(index: number = 1) {
    this.go(index)
  }
  back(index: number = 1) {
    this.go(-index)
  }
  go(index: number) {
    this.currentRouteIndex += index
    if (this.currentRouteIndex < 0) {
      this.currentRouteIndex = 0
    } else if (this.currentRouteIndex >= this.history.length) {
      this.currentRouteIndex = this.history.length - 1
    }
    this.currentRoute = this.history[this.currentRouteIndex]
    this.eventEmitter.emit('changeRoute', this.currentRoute)
  }
  push(route: RouterPushParams) {
    const component = this.registeredRoutes.find(
      (r) => r.name === route.name,
    )?.component
    if (!component) throw new NotRegisteredRouteError(route.name)
    this.currentRouteIndex++
    if (route.props) {
      markRaw(route.props)
    }
    const historyObj = {
      name: route.name,
      component,
      props: route.props,
      events: route.events,
    }
    this.history.push(historyObj)
    this.currentRoute = historyObj
    this.eventEmitter.emit('changeRoute', this.currentRoute)
  }
  close() {
    this.eventEmitter.emit('close')
    this.history.length = 0
    this.currentRouteIndex = -1
    this.currentRoute = undefined
  }
}

export { PopupRouter }
